export enum AxiosHeaderEnum {
  HEADER_BLOB = 'HEADER_BLOB',
  HEADER = 'HEADER',
  HEADER_FORMDATA = 'HEADER_FORMDATA',
}
